import Vue from 'vue'
import Vuex from 'vuex'
import { dataApi } from '../api/dataManagement'
import users from './modules/users'
import groups from './modules/groups'
import emailTemplates from './modules/emailTemplates'
import surveys from './modules/surveys'
import auth from './modules/auth'
import { surveyApi } from '@/api/surveyManagement'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    schools: [],
    departments: [],
    modules: [],
    staff: [],
    studentCount: 0,
    settings: null
  },
  mutations: {
    SET_SCHOOLS(state, schools) {
      state.schools = schools
    },
    SET_DEPARTMENTS(state, departments) {
      state.departments = departments
    },
    SET_MODULES(state, modules) {
      state.modules = modules
    },
    SET_STAFF(state, staff) {
      state.staff = staff
    },
    SET_STUDENT_COUNT(state, count) {
      state.studentCount = count
    },
    SET_INST_INFO(state, result){
      state.settings = result
    }
  },
  actions: {
    async fetchSchools({ commit }) {
      try {
        const schools = await dataApi.fetchSchools()
        commit('SET_SCHOOLS', schools)
      } catch (error) {
        console.error('Error fetching schools:', error)
      }
    },
    async fetchDepartments({ commit }) {
      try {
        const departments = await dataApi.fetchDepartments()
        commit('SET_DEPARTMENTS', departments)
      } catch (error) {
        console.error('Error fetching departments:', error)
      }
    },
    async fetchModules({ commit }) {
      try {
        const modules = await dataApi.fetchModules()
        commit('SET_MODULES', modules)
      } catch (error) {
        console.error('Error fetching modules:', error)
      }
    },
    async fetchStaff({ commit }) {
      try {
        const staff = await dataApi.fetchStaff()
        commit('SET_STAFF', staff)
      } catch (error) {
        console.error('Error fetching staff:', error)
      }
    },
    async fetchInstitutionSettings({commit}){
      const result = await surveyApi.getInstitutionSettings();
      commit('SET_INST_INFO', result)
    },
    async fetchStudentCount({ commit }) {
      try {
        const result = await dataApi.fetchData('students', 1, 1, {});
        commit('SET_STUDENT_COUNT', result.totalCount);
      } catch (error) {
        console.error('Error fetching student count:', error);
      }
    },
    async fetchAllData({ dispatch }) {
      await Promise.all([
        dispatch('fetchSchools'),
        dispatch('fetchDepartments'),
        dispatch('fetchModules'),
        dispatch('fetchStaff'),
        dispatch('fetchStudentCount'),
        dispatch('users/fetchAdmins'),
        dispatch('groups/fetchGroups')
      ])
    }
  },
  getters: {
    getSchools: state => state.schools,
    getDepartments: state => state.departments,
    getModules: state => state.modules,
    getStaff: state => state.staff,
    getStudentCount: state => state.studentCount,
    getSettings: state => state.settings
  },
  modules: {
    users,
    groups,
    emailTemplates,
    surveys,
    auth
  }
})

